import React, { useState } from 'react';
import { MapPin, Navigation, Loader2 } from 'lucide-react';
import { useLocation } from '../contexts/LocationContext';
import { Button } from './ui/button';

const LocationButton = ({ onLocationUpdate, className = '', style = {} }) => {
  const { 
    currentLocation, 
    address, 
    isLoading, 
    requestLocationPermission,
    isGeolocationSupported 
  } = useLocation();
  
  const [isRequesting, setIsRequesting] = useState(false);

  const handleLocationRequest = async () => {
    if (!isGeolocationSupported) {
      alert('Geolocation is not supported by this browser');
      return;
    }

    setIsRequesting(true);
    try {
      const result = await requestLocationPermission();
      if (result && onLocationUpdate) {
        onLocationUpdate({
          location: currentLocation,
          address: address
        });
      }
    } catch (error) {
      console.error('Location request failed:', error);
    } finally {
      setIsRequesting(false);
    }
  };

  if (!isGeolocationSupported) {
    return null;
  }

  return (
    <Button
      onClick={handleLocationRequest}
      disabled={isLoading || isRequesting}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '12px 16px',
        backgroundColor: currentLocation ? '#10b981' : '#3b82f6',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '600',
        cursor: isLoading || isRequesting ? 'not-allowed' : 'pointer',
        opacity: isLoading || isRequesting ? 0.7 : 1,
        transition: 'all 0.2s ease',
        ...style
      }}
      className={className}
    >
      {isLoading || isRequesting ? (
        <>
          <Loader2 style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
          Getting Location...
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </>
      ) : currentLocation ? (
        <>
          <Navigation style={{ width: '16px', height: '16px' }} />
          {address ? 'Update Location' : 'Location Found'}
        </>
      ) : (
        <>
          <MapPin style={{ width: '16px', height: '16px' }} />
          Use My Location
        </>
      )}
    </Button>
  );
};

export default LocationButton;





